import React from 'react';
import { AiPanelLink } from '@tools/shared';
import { IconSize, IconType, IconWrap, semanticTheme } from '@tools/ui/dime';
import { LinkAnchor } from './AiPanelBlock.styles';

export const AiPanelLinkView: React.FC<{ link: AiPanelLink }> = ({ link }) => (
  <LinkAnchor
    href={link.href}
    target={link.external ? '_blank' : undefined}
    rel={link.external ? 'noopener noreferrer' : undefined}
  >
    {link.text}
    {!!link.external && (
      <IconWrap
        type={IconType.ExternalLink}
        size={IconSize.Small}
        color={semanticTheme.dime.colors.link.primary}
      />
    )}
  </LinkAnchor>
);
